module.exports = {
      id: "icons:heart-usage",
      viewBox: "0 0 18 16",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#icons:heart-usage",
      toString: function () {
        return this.url;
      }
    }